import GenericEmail from 'components/signupAuthentication/email';
import { Household } from 'features/household/models';
import { CustomComponentProps } from 'models/questionnaireFramework';

export const Email = ({
  routes,
  onSubmitValue,
}: CustomComponentProps<Household>) => (
  <GenericEmail
    verticalId="household"
    redirectPath={routes.name.path}
    onContinueWithCurrentAccount={(account) => {
      onSubmitValue(account);
    }}
  />
);
